import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const fmt = v => 'R$ ' + parseFloat(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
const fmtData = d => d ? new Date(d).toLocaleDateString('pt-BR') : '—';
const toISO = d => d.toISOString().split('T')[0];

const exportarExcel = (dados, inicio, fim) => {
  const header = ['Data Venda','Veículo','Cliente','Vendedor','Valor Compra','Despesas','Valor Venda','Lucro Bruto'];
  const rows = dados.vendas.map(v => [
    v.data_venda ? new Date(v.data_venda).toLocaleDateString('pt-BR') : '',
    v.marca + ' ' + v.modelo + ' ' + (v.ano_mod||''),
    v.cliente_nome || '',
    v.vendedor_nome || '',
    parseFloat(v.valor_compra||0).toFixed(2).replace('.',','),
    parseFloat((parseFloat(v.valor_final||0) - parseFloat(v.valor_compra||0) - parseFloat(v.lucro_bruto||0) - parseFloat(v.valor_final||0) + parseFloat(v.lucro_bruto||0) + parseFloat(v.valor_compra||0))||0).toFixed(2).replace('.',','),
    parseFloat(v.valor_final||0).toFixed(2).replace('.',','),
    parseFloat(v.lucro_bruto||0).toFixed(2).replace('.',','),
  ]);
  // Calcular despesas = valor_final - valor_compra - lucro_bruto
  const rowsFixed = dados.vendas.map(v => {
    const despesas = parseFloat(v.valor_final||0) - parseFloat(v.valor_compra||0) - parseFloat(v.lucro_bruto||0);
    return [
      v.data_venda ? new Date(v.data_venda).toLocaleDateString('pt-BR') : '',
      (v.marca||'') + ' ' + (v.modelo||'') + ' ' + (v.ano_mod||''),
      v.cliente_nome || '',
      v.vendedor_nome || '',
      parseFloat(v.valor_compra||0).toFixed(2).replace('.',','),
      despesas.toFixed(2).replace('.',','),
      parseFloat(v.valor_final||0).toFixed(2).replace('.',','),
      parseFloat(v.lucro_bruto||0).toFixed(2).replace('.',','),
    ];
  });
  const totalLucro = dados.vendas.reduce((a,b) => a + parseFloat(b.lucro_bruto||0), 0);
  const totalVendas = dados.vendas.reduce((a,b) => a + parseFloat(b.valor_final||0), 0);
  rowsFixed.push(['','','','','','','TOTAL', totalVendas.toFixed(2).replace('.',',')]);
  rowsFixed.push(['','','','','','','LUCRO TOTAL', totalLucro.toFixed(2).replace('.',',')]);
  const csvContent = [header, ...rowsFixed].map(r => r.map(c => '"' + String(c).replace(/"/g,'""') + '"').join(';')).join('\n');
  const blob = new Blob(['﻿' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'relatorio_lucro_' + (inicio||'') + '_' + (fim||'') + '.csv';
  a.click();
  URL.revokeObjectURL(url);
};

const exportarPDF = (dados, inicio, fim) => {
  const totalLucro = dados.vendas.reduce((a,b) => a + parseFloat(b.lucro_bruto||0), 0);
  const totalVendas = dados.vendas.reduce((a,b) => a + parseFloat(b.valor_final||0), 0);
  const fmtR = v => 'R$ ' + parseFloat(v||0).toLocaleString('pt-BR',{minimumFractionDigits:2});
  let linhas = '';
  dados.vendas.forEach(v => {
    const despesas = parseFloat(v.valor_final||0) - parseFloat(v.valor_compra||0) - parseFloat(v.lucro_bruto||0);
    linhas += '<tr>' +
      '<td>' + (v.data_venda ? new Date(v.data_venda).toLocaleDateString('pt-BR') : '') + '</td>' +
      '<td>' + (v.marca||'') + ' ' + (v.modelo||'') + ' ' + (v.ano_mod||'') + '</td>' +
      '<td>' + (v.cliente_nome||'') + '</td>' +
      '<td style="text-align:right">' + fmtR(v.valor_compra) + '</td>' +
      '<td style="text-align:right">' + fmtR(despesas) + '</td>' +
      '<td style="text-align:right">' + fmtR(v.valor_final) + '</td>' +
      '<td style="text-align:right;color:#B06000;font-weight:700">' + fmtR(v.lucro_bruto) + '</td>' +
    '</tr>';
  });
  const html = '<!DOCTYPE html><html><head><meta charset="utf-8"><title>Relatorio de Lucro</title>' +
    '<style>body{font-family:Arial,sans-serif;font-size:11px;margin:20px;color:#1C2533}' +
    'h2{color:#1A3A5C;margin-bottom:4px}p{color:#6B7A8D;margin:0 0 16px}' +
    'table{width:100%;border-collapse:collapse}' +
    'th{background:#1A3A5C;color:#fff;padding:7px 8px;text-align:left;font-size:10px}' +
    'td{padding:6px 8px;border-bottom:0.5px solid #e0e0e0}' +
    'tr:nth-child(even) td{background:#F8F9FC}' +
    '.total{font-weight:700;font-size:12px;text-align:right;margin-top:12px}' +
    '.lucro{color:#B06000;font-size:14px;font-weight:700}' +
    '@media print{body{margin:10px}}</style></head><body>' +
    '<h2>AUTOPMOTOS - Relatorio de Lucro por Venda</h2>' +
    '<p>Periodo: ' + (inicio||'') + ' a ' + (fim||'') + ' - ' + dados.vendas.length + ' vendas</p>' +
    '<table><thead><tr><th>Data</th><th>Veiculo</th><th>Cliente</th><th>Compra</th><th>Despesas</th><th>Venda</th><th>Lucro Bruto</th></tr></thead>' +
    '<tbody>' + linhas + '</tbody></table>' +
    '<div class="total">Total Vendas: ' + fmtR(totalVendas) + '</div>' +
    '<div class="total lucro">Lucro Total: ' + fmtR(totalLucro) + '</div>' +
    '<script>window.onload=function(){window.print()}<' + '/script>' +
    '</body></html>';
  const w = window.open('', '_blank');
  w.document.write(html);
  w.document.close();
};


const inpStyle = { width: '100%', padding: '8px 10px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', color: '#1C2533', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", boxSizing: 'border-box' };
const lbl = { color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.3px' };
const th = { padding: '0 12px 10px 0', color: '#9AA3AE', fontSize: '10.5px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.4px', textAlign: 'left', borderBottom: '0.5px solid rgba(26,58,92,0.1)' };
const td = { padding: '10px 12px 10px 0', borderBottom: '0.5px solid rgba(26,58,92,0.07)', fontSize: '13px', color: '#1C2533', verticalAlign: 'middle' };

const filtros = [
  { key: 'mes', label: 'Este mês' },
  { key: 'trimestre', label: 'Últimos 3 meses' },
  { key: 'semestre', label: 'Últimos 6 meses' },
  { key: 'ano', label: 'Este ano' },
];

export default function Relatorios() {
  const [inicio, setInicio] = useState('');
  const [fim, setFim] = useState('');
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filtroAtivo, setFiltroAtivo] = useState('');
  const navigate = useNavigate();

  const buscarRapido = async (tipo) => {
    const h = new Date();
    let ini, fi;
    if (tipo === 'mes') { ini = new Date(h.getFullYear(), h.getMonth(), 1); fi = new Date(h.getFullYear(), h.getMonth() + 1, 0); }
    else if (tipo === 'trimestre') { ini = new Date(h.getFullYear(), h.getMonth() - 2, 1); fi = h; }
    else if (tipo === 'semestre') { ini = new Date(h.getFullYear(), h.getMonth() - 5, 1); fi = h; }
    else if (tipo === 'ano') { ini = new Date(h.getFullYear(), 0, 1); fi = h; }
    setFiltroAtivo(tipo);
    setInicio(toISO(ini));
    setFim(toISO(fi));
    setLoading(true);
    try {
      const r = await api.get('/relatorios/vendas-periodo', { params: { inicio: toISO(ini), fim: toISO(fi) } });
      setDados(r.data);
    } catch (e) { alert('Erro: ' + e.message); }
    finally { setLoading(false); }
  };

  const buscar = async () => {
    setLoading(true);
    try {
      const r = await api.get('/relatorios/vendas-periodo', { params: { inicio, fim } });
      setDados(r.data);
    } catch (e) { alert('Erro: ' + e.message); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533', marginBottom: '20px' }}>Relatórios de Vendas</div>

      <div style={{ background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '10px', padding: '18px 20px', marginBottom: '16px' }}>
        <div style={{ display: 'flex', gap: '6px', marginBottom: '16px', flexWrap: 'wrap' }}>
          {filtros.map(f => (
            <button key={f.key} onClick={() => buscarRapido(f.key)}
              style={{ padding: '7px 14px', background: filtroAtivo === f.key ? '#1A3A5C' : '#F4F6F9', border: 'none', color: filtroAtivo === f.key ? '#fff' : '#6B7A8D', borderRadius: '7px', cursor: 'pointer', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", fontWeight: filtroAtivo === f.key ? '600' : '400' }}>
              {f.label}
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', gap: '14px', alignItems: 'flex-end' }}>
          <div style={{ flex: 1 }}>
            <label style={lbl}>Período — Início</label>
            <input type='date' value={inicio} onChange={e => { setInicio(e.target.value); setFiltroAtivo(''); }} style={inpStyle} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={lbl}>Fim</label>
            <input type='date' value={fim} onChange={e => { setFim(e.target.value); setFiltroAtivo(''); }} style={inpStyle} />
          </div>
          <button onClick={buscar} disabled={loading}
            style={{ padding: '9px 20px', background: '#1A3A5C', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif", whiteSpace: 'nowrap' }}>
            {loading ? 'Buscando...' : 'Buscar'}
          </button>
        </div>
      </div>

      {dados && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '14px', marginBottom: '16px' }}>
            {[
              { label: 'Vendas', val: dados.quantidade, color: '#1E5FA5', mono: false },
              { label: 'Faturamento', val: fmt(dados.total_vendas), color: '#2D7D4F', mono: true },
              { label: 'Lucro bruto', val: fmt(dados.total_lucro), color: '#B06000', mono: true },
              { label: 'Ticket médio', val: fmt(dados.quantidade > 0 ? dados.total_vendas / dados.quantidade : 0), color: '#1E5FA5', mono: true },
            ].map(item => (
              <div key={item.label} style={{ background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '10px', padding: '16px 18px' }}>
                <div style={{ fontSize: '11px', fontWeight: '600', color: '#6B7A8D', textTransform: 'uppercase', letterSpacing: '0.3px', marginBottom: '10px' }}>{item.label}</div>
                <div style={{ background: '#F4F6F9', borderRadius: '8px', padding: '12px 14px' }}>
                  <div style={{ fontSize: item.mono ? '18px' : '26px', fontWeight: '700', fontFamily: item.mono ? "'DM Mono',monospace" : "'DM Sans',system-ui,sans-serif", color: item.color }}>{item.val}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginBottom: '10px' }}>
            <button onClick={() => exportarExcel(dados, inicio, fim)} style={{ padding: '7px 14px', background: '#2D7D4F', color: '#fff', border: 'none', borderRadius: '7px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" }}>⬇ Exportar Excel</button>
            <button onClick={() => exportarPDF(dados, inicio, fim)} style={{ padding: '7px 14px', background: '#1A3A5C', color: '#fff', border: 'none', borderRadius: '7px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" }}>🖨 Exportar PDF</button>
          </div>
          <div style={{ background: '#fff', border: '0.5px solid rgba(26,58,92,0.12)', borderRadius: '10px', padding: '16px 18px' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>{['Data Venda', 'Entrega', 'Veículo', 'Cliente', 'Vendedor', 'Valor Venda', 'Lucro Bruto'].map(h => <th key={h} style={th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {dados.vendas.length === 0 && <tr><td colSpan={7} style={{ ...td, textAlign: 'center', color: '#9AA3AE', padding: '32px 0' }}>Nenhuma venda no período</td></tr>}
                {dados.vendas.map(v => (
                  <tr key={v.id}>
                    <td style={{ ...td, color: '#6B7A8D', fontSize: '12px', fontFamily: "'DM Mono',monospace" }}>{fmtData(v.data_venda)}</td>
                    <td style={td}>
                      {v.data_entrega
                        ? <span style={{ background: '#EAF5EE', color: '#2D7D4F', padding: '2px 7px', borderRadius: '20px', fontSize: '11px', fontWeight: '600' }}>{fmtData(v.data_entrega)}</span>
                        : <span style={{ background: '#FFF3E0', color: '#B06000', padding: '2px 7px', borderRadius: '20px', fontSize: '11px', fontWeight: '600' }}>Pendente</span>}
                    </td>
                    <td style={{ ...td, fontWeight: '500' }}><span onClick={() => window.open('/estoque/' + v.veiculo_id, '_blank')} style={{ color: '#1A3A5C', cursor: 'pointer', textDecoration: 'underline' }}>{v.marca} {v.modelo} {v.ano_mod}</span></td>
                    <td style={{ ...td, color: '#6B7A8D' }}>{v.cliente_nome}</td>
                    <td style={{ ...td, color: '#6B7A8D' }}>{v.vendedor_nome}</td>
                    <td style={{ ...td, color: '#2D7D4F', fontWeight: '700', fontFamily: "'DM Mono',monospace", fontSize: '12px' }}>{fmt(v.valor_final)}</td>
                    <td style={{ ...td, color: '#B06000', fontWeight: '700', fontFamily: "'DM Mono',monospace", fontSize: '12px' }}>{fmt(v.lucro_bruto)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
